import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88de7142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "living" }
const _hoisted_2 = { class: "living_top" }
const _hoisted_3 = {
  key: 0,
  class: "living_top_more"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "living_scroll"
}

import { withDefaults, defineAsyncComponent } from 'vue';
interface Props {
  component: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Living',
  props: {
    component: { default: Object }
  },
  setup(__props: any) {

const props = __props as { component: any };

const LiveItem = defineAsyncComponent(() => import('../live/LiveItem.vue'));



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(props.component.title), 1),
      (props.component.liveList.length > props.component.most)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "更多>>"))
        : _createCommentVNode("", true)
    ]),
    (props.component.style !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.liveList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(
          index + 1 !== props.component.most && props.component.style == 0 && index < props.component.most ? 'living_item' : ''
        ),
              key: item.id
            }, [
              (index < props.component.most)
                ? (_openBlock(), _createBlock(_unref(LiveItem), {
                    key: 0,
                    "data-source": item
                  }, null, 8, ["data-source"]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (props.component.style == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.liveList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "living_scroll_item",
              key: item.id
            }, [
              (index < props.component.most)
                ? (_openBlock(), _createBlock(_unref(LiveItem), {
                    key: 0,
                    class: "scroll_item_live",
                    "data-source": item
                  }, null, 8, ["data-source"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})